module.exports = __webpack_public_path__ + "img/Yale_logo.9d9c341.75883ccc.svg";